class Utils {
    static isUndefined = (obj) => typeof obj === 'undefined' || obj === null;

    static getParam = (p) => {
        const match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    };

    /**
     * Helper to get a URL parameter, case-insensitively.
     * @param {string} key - The parameter key to search for.
     * @returns {string|null} The parameter value or null if not found.
     */
    static getParamCaseInsensitive = (key) => {
        return Utils.getParam(key) ?? Utils.getParam(key.toUpperCase());
    };

    /**
     * @param {string} slug
     * @returns {bool}
     */
    static isPage = (slug) => {
        const cleanSlug = slug.replace(/^\/|\/$/g, '').toLowerCase();

        const pathSegments = window.location.pathname.split('/').filter((path) => path !== '');

        if (pathSegments.length === 0) {
            return cleanSlug === '';
        }

        const lastUrlPathSegment = pathSegments.pop().toLowerCase();

        return lastUrlPathSegment === cleanSlug;
    };
}

export default Utils;
